import { render, staticRenderFns } from "./VenueOpeningHours.vue?vue&type=template&id=4274f66b&"
import script from "./VenueOpeningHours.vue?vue&type=script&lang=js&"
export * from "./VenueOpeningHours.vue?vue&type=script&lang=js&"
import style0 from "./VenueOpeningHours.vue?vue&type=style&index=0&id=4274f66b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports